<template>
    <div id="contact_create_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customercontactHeader" v-if="$route.params.id > 0">Update Customer Contact</span>
                    <span class="page-title" id="customercontactHeader" v-else>Add Customer Contact</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackCustomerContactList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contact-crud">
                        <!--Print Backend Error message-->
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CustomerContactForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id" id="customer_id"
                                                label="text" :filterable="false" :options="customerArr"
                                                @search="onSearchCustomer"
                                                placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customererrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Contact Person Name" name="name">
                                        <div class="field-error">{{ name_error_msg }}</div>

                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="email">Email:</label>
                                        <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter email" name="email">
                                        <div class="field-error">{{ email_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="fax_no">Fax No:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="fax_no" id="fax_no" placeholder="999-999-9999" name="fax_no">
                                        <!-- <input-mask id="fax_no" :alwaysShowMask="true" name="fax_no" v-model="fax_no" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{faxerrors}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="zip">Zip:</label>
                                        <input type="text" class="form-control" v-model="zip" id="zip" placeholder="Enter Zip" name="zip" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{ zip_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label require" for="address_1"> Address: </label>
                                        </div>
                                        <input type="text" class="form-control" v-model="address_1" id="address_1" placeholder="Enter Address" name="address_1">
                                        <div class="field-error">{{address_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label" for="address_2">Address Line 2: </label>
                                        </div>
                                        <input type="text" class="form-control" v-model="address_2" id="address_2" placeholder="Enter Address Line 2" name="address_2">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">State:</label>
                                        <v-select v-model="state" name="state"
                                                label="text" :filterable="false" :options="stateArr"
                                                @search="onSearchState"
                                                placeholder="Select State" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{state_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="city_id">City:</label>
                                        <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> 
                                            <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City
                                        </a>
                                        <v-select v-model="city_id" name="city_id"
                                                label="text" :filterable="false" :options="cityArr"
                                                @search="onSearchCity"
                                                placeholder="Select City" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search City...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{city_err_msg}}</div>
                                        <div class="field-error">{{city_error_msg}}</div>
                                    </div>
                                     <template v-if = "canAddCity">
                                          <div class="citycreate wo-vendorinv-form" >
                                              <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                                          </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Designation:</label>
                                        <v-select v-model="designation" name="designation" placeholder="Select Designation."
                                                label="text"
                                                :options="designationsArr">
                                        </v-select>
                                        <div class="field-error">{{ designation_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label">Default:</label>
                                        <i class="fa fa-info-circle" aria-hidden="true" ></i>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_default"> Yes
                                                    <input type="radio" v-model="is_default" :value="1" id="is_default" name="is_default">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="is_default1"> No
                                                    <input type="radio" v-model="is_default" :value="0" id="is_default1" name="is_default">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="invoices">Send E-mail Notification:</label>
                                        <div class="custom-checkbox">
                                            <template v-for="(obj,key) in sendEmailNotificationTypesArr">
                                                <div class="" :key="key">
                                                    <label class="checkbox-custom">{{ obj.name }}
                                                        <input type="checkbox" v-model="sendNotificationTypes" v-bind:value="obj.id" v-bind:id="obj.name + obj.id" :name="obj.name" @change="emailNotificationType(obj.id,obj.name,$event)">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require">Phone Number:</label>
                                        <div class="form-row">
                                            <div class="col-auto">
                                                <div class="add-multi-phoneno">
                                                    <div class="form-group" id="div_work_phone">
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="">Work Phone</span>
                                                            </div>
                                                            <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="work_phone" id="work_phone" placeholder="999-999-9999" name="work_phone">
                                                            <!-- <input-mask id="work_phone" :alwaysShowMask="true" name="work_phone" v-model="work_phone" mask="999-999-9999" class="form-control" type="tel">
                                                            </input-mask> -->
                                                        </div>
                                                        <div class="field-error phone-fl-error">{{work_phone_number_error_msg}}</div>
                                                    </div>
                                                    <div class="form-group" id="div_mobile_phone" v-if="isMobPhoneNumberEnabled">
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="">Mobile Phone</span>
                                                            </div>
                                                            <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="mobile_phone" id="mobile_phone" placeholder="999-999-9999" name="mobile_phone">
                                                            <!-- <input-mask id="mobile_phone" :alwaysShowMask="true" name="mobile_phone" v-model="mobile_phone" mask="999-999-9999" class="form-control" type="tel">
                                                            </input-mask> -->
                                                            <span class="fp-remove remove-phone" v-on:click.prevent="clearPhoneNumber(isMobPhoneNumberEnabled)"></span>
                                                        </div>
                                                        <div class="field-error phone-fl-error">{{mobile_phone_number_error_msg}}</div>
                                                    </div>
                                                    <div class="form-group" id="div_home_phone" v-if="isHomePhoneNumberEnabled">
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="">Home Phone</span>
                                                            </div>
                                                            <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="home_phone" id="home_phone" placeholder="999-999-9999" name="home_phone">
                                                            <!-- <input-mask id="home_phone" :alwaysShowMask="true" name="home_phone" v-model="home_phone" mask="999-999-9999" class="form-control" type="tel">
                                                            </input-mask> -->
                                                            <span class="fp-remove remove-phone" v-on:click.prevent="clearPhoneNumber(isHomePhoneNumberEnabled)"></span>
                                                        </div>
                                                        <div class="field-error phone-fl-error">{{home_phone_number_error_msg}}</div>
                                                    </div>
                                                    <div class="form-group" id="div_other_phone" v-if="isOtherPhoneNumberEnabled">
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="">Other Phone</span>
                                                            </div>
                                                            <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="other_phone" id="other_phone" placeholder="999-999-9999" name="other_phone">
                                                            <!-- <input-mask id="other_phone" :alwaysShowMask="true" name="other_phone" v-model="other_phone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                                            <span class="fp-remove remove-phone" v-on:click.prevent="clearPhoneNumber(isOtherPhoneNumberEnabled)"></span>
                                                        </div>
                                                        <div class="field-error phone-fl-error">{{other_phone_number_error_msg}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-auto" v-if="showPhoneBtn==true">
                                                <button class="btn btn-primary" id="add_phone" type="button" v-on:click.prevent="addPhoneNumber()" > <i class="fp-add-phone"> </i> Add Phone </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateCustomerContactBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCustomerContact" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateCustomerContactBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCustomerContact" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCustomerContactBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCustomerContact(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCustomerContactBtn" class="btn btn-tertiary" v-on:click.prevent="BackCustomerContactList" >
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

// import InputMask from 'vue-input-mask';
// Vue.component('input-mask', InputMask)

import {commonMixins} from '../mixins/commonMixins';

import CityCreate from '@/components/CityCreate.vue';
Vue.component("city-add-form", CityCreate);

export default {
  name: "CustomerContactCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Customer Contact | " +process.env.COPYRIGHT_NAME : "Create Customer Contact | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins:[commonMixins],
  data: () => ({
    canAddCity:false,
    city_error_msg:"",
    permissions: [],
    cantAccessPage: "",
    customer_id: null,
    customerArr: [],
    name: "",
    email: "",
    is_default: 0,
    work_phone: "",
    home_phone: "",
    mobile_phone: "",
    other_phone: "",
    address_1: "",
    address_err_msg: "",
    address_2: "",
    state: null,
    stateArr: [],
    state_err_msg: "",
    city_id: null,
    cityArr: [],
    city_err_msg: "",
    fax_no: "",
    faxerrors: "",
    zip: "",
    zip_error_msg: "",
    loading:false,
    customererrors: "",
    name_error_msg: "",
    email_error_msg: "",
    work_phone_number_error_msg: "",
    home_phone_number_error_msg: "",
    mobile_phone_number_error_msg: "",
    other_phone_number_error_msg: "",
    cpi_rate_increase_mail: 0,
    maintenance_mail: 0,
    invoices: 0,
    maintenance_mail_value: 0,
    invoices_value: 0,
    cpi_rate_increase_mail_value: 0,
    designation:'',
    designation_error_msg:'',
    sendEmailNotificationTypesArr:[],
    sendNotificationTypes:[],
    showPhoneBtn:true,
    isMobPhoneNumberEnabled:false,
    isHomePhoneNumberEnabled:false,
    isOtherPhoneNumberEnabled:false,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_customer_contact') {
                        self.cantAccessPage = true;

                        setTimeout(function () {

                            /*var customerId = self.$route.query.customerId;
                            var customer_name = self.$route.query.customerName;
                            var customer_code = self.$route.query.customerCode;

                            if (customerId) {

                                $("#customer_id").addClass("js-example-disabled");
                                self.customer_id = {value: customerId, text: customer_code + " | " + customer_name};
                                self.name = customer_name;
                                self.$swal('','Default Customer Contact with provided details has been created.','info');
                            }*/

                            var webloc = window.location.href;
                            var decodeStr = "";
                            if ( self.$route.query.data != '' && self.$route.query.data != undefined ) {

                                decodeStr = atob(self.$route.query.data);
                                var url = new URL(webloc+"?"+decodeStr);
                                var customerId = url.searchParams.get("customerId");
                                var customer_name = url.searchParams.get("customerName");
                                var customer_code = url.searchParams.get("customerCode");
                                var address_1 = url.searchParams.get("address_1");
                                var address_2 = url.searchParams.get("address_2");
                                var phone_no = url.searchParams.get("phone_no");
                                var stateId = url.searchParams.get("stateId");
                                var stateVal = url.searchParams.get("stateVal");
                                var cityId = url.searchParams.get("cityId");
                                var cityVal = url.searchParams.get("cityVal");

                                if (customerId) {

                                    $("#customer_id").addClass("js-example-disabled");
                                    self.customer_id = {value: customerId, text: customer_code + " | " + customer_name};
                                    self.name = customer_name;
                                    self.address_1 = address_1;
                                    self.address_2 = address_2;
                                    if (phone_no != null || phone_no != "") {
                                        self.work_phone = phone_no;
                                    }
                                    if (stateId != null && stateId != "") {
                                        self.state = { value: stateId, text: stateVal};
                                    }
                                    if (cityId != null && cityId != "") {
                                        self.city_id = { value: cityId, text: cityVal};
                                    }
                                    self.$swal('','Default Customer Contact with provided details has been created.','info');
                                }

                            }

                        }, 100);
                    }
                }
            }

        },

        //if state value update after then change the city value also update that in thie module.
        state: function(state) {

            var self = this;

            if(self.state == null){
                self.city_id = null;
                self.cityArr = [];
            }
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.getNotificationData();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {

            self.loadCustomerContact();

        }
  },
  methods: {

    popCityName(cid){
         console.log("check"+cid);
        // this.city_id =cid;
         this.city_id = {value: cid.id, text: cid.name};
    },
    
    getNotificationData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/get-notification-data",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    /*self.invoices_value = data.content[0].id;
                    self.cpi_rate_increase_mail_value = data.content[1].id;
                    self.maintenance_mail_value = data.content[2].id;*/
                    self.sendEmailNotificationTypesArr = data.content;
                    // $("#invoices").value = data.content[0].id;
                    // $("#cpi_rate_increase_mail").value = data.content[1].id;

                    // $("#invoices").val(data.content[0].id);
                    // $("#cpi_rate_increase_mail").val(data.content[1].id);
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'get-notification')
            }
        });

    },

    onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
    },

    onSearchCity(search, loading) {

        var self = this;
        if (search.length > 2) {

            var stateId = self.state.value;
            if ( stateId == "" ) {
                alert("please select state first");
                return;
            }

            loading(true);
            self.searchField(loading, search, 'city', '');
        }
    },
    addPhoneNumber() {

        var self = this;

        if ( self.isMobPhoneNumberEnabled == false ) {
            self.isMobPhoneNumberEnabled = true;
            self.checkallPhoneInput();
            return;
        }

        if ( self.isHomePhoneNumberEnabled == false ) {
            self.isHomePhoneNumberEnabled = true;
            self.checkallPhoneInput();
            return;
        }

        if ( self.isOtherPhoneNumberEnabled == false) {
            self.isOtherPhoneNumberEnabled = true;
            self.checkallPhoneInput();
            return;
        }

    },
    checkallPhoneInput(){
         var self = this;
         if ( self.isMobPhoneNumberEnabled == false ||  self.isHomePhoneNumberEnabled == false  ||  self.isOtherPhoneNumberEnabled == false  ) {
            self.showPhoneBtn=true;

         }else{
            self.showPhoneBtn=false;
         }
    },
    clearPhoneNumber(flagPhoneNumber){

        var self = this;
        if (flagPhoneNumber == self.isMobPhoneNumberEnabled) {
            self.isMobPhoneNumberEnabled = false;
            self.mobile_phone_number_error_msg = "";
        }
        else if (flagPhoneNumber == self.isHomePhoneNumberEnabled) {
            self.isHomePhoneNumberEnabled = false;
            self.home_phone_number_error_msg = "";
        }
        else if (flagPhoneNumber == self.isOtherPhoneNumberEnabled) {
            self.isOtherPhoneNumberEnabled = false;
            self.other_phone_number_error_msg = "";
        }

        self.checkallPhoneInput();
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },

    BackCustomerContactList() {
      var self = this;
      self.$router.push("/customercontact/list");
    },

    CreateCustomerContact(flag) {
      var self = this;
      var error = false;

      self.customererrors = "";
      self.name_error_msg = "";
      self.email_error_msg = "";
      self.work_phone_number_error_msg = "";
      self.home_phone_number_error_msg = "";
      self.mobile_phone_number_error_msg = "";
      self.other_phone_number_error_msg = "";
      self.address_err_msg = "";
      self.state_err_msg = "";
      self.city_err_msg = "";
      self.zip_error_msg = "";
      self.faxerrors = "";
      self.designation_error_msg = '';


      if (self.customer_id == null || !self.customer_id.value) {
        self.customererrors = "Customer Name is Required.";
        error = true;
      }

      if (self.city_id == null || !self.city_id.value) {
        self.city_err_msg = "City is Required.";
        error = true;
      }

      if (self.state == null || !self.state.value) {
        self.state_err_msg = "State is Required.";
        error = true;
      }

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name is Required.";
        error = true;
      }

      if (!self.zip || self.zip == null || self.zip == "") {
        self.zip_error_msg = "Zip is Required.";
        error = true;
      }

      if(self.zip && (self.zip.length > 5 || self.zip.length < 5) ){
        //console.log("test123");
        self.zip_error_msg = "Zip Must Consist of 5 Digits";
        error = true;
      }

      if (!self.email || self.email == null || self.email == "") {
        self.email_error_msg = "Email is Required.";
        error = true;
      }

      if (self.email && !self.validEmail(self.email)) {
        self.email_error_msg = "Enter Valid Email.";
        error = true;
      }
    //   if (!self.designation || self.designation == null || self.designation == "") {
    //     self.designation_error_msg = "Designation is Required.";
    //     error = true;
    //   }
      if (self.designation == null || !self.designation.value) {
        self.designation_error_msg = "Designation is Required.";
        error = true;
      }
      if (!self.address_1 || self.address_1 == null || self.address_1 == "") {
        self.address_err_msg = "Address is Required.";
        error = true;
      }

      if (!self.work_phone || self.work_phone == null || self.work_phone == "" || self.work_phone == "___-___-____" ) {
        self.work_phone_number_error_msg = "Work Phone is Required.";
        error = true;
      }

    /*   if(self.work_phone && !String(self.work_phone).match(/^[0-9]*$/)){
        self.work_phone_number_error_msg = "Work Phone Must Be Numeric";
        error = true;
      }

      if(self.work_phone && String(self.work_phone).match(/^[0-9]*$/) && self.work_phone.length < 10){
        self.work_phone_number_error_msg = "Work Phone Must Be Of Minimum 10 Digits";
        error = true;
      }

      if(self.work_phone && String(self.work_phone).match(/^[0-9]*$/) && self.work_phone.length > 12){
        self.work_phone_number_error_msg = "Work Phone Must Be Of Maximum 12 Digits";
        error = true;
      } */

      var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

      if(self.work_phone && self.work_phone != "___-___-____"  &&  !self.work_phone.match(phoneRE)){
        self.work_phone_number_error_msg = "Work phone number must be in proper format";
        error = true;
      }
      if (!$("#div_mobile_phone").hasClass("hide")) {
        if(self.mobile_phone && self.mobile_phone != "___-___-____" && !self.mobile_phone.match(phoneRE)){
            console.log("div_mobile_phone IF");
            self.mobile_phone_number_error_msg = "Mobile phone number must be in proper format";
            error = true;
        }
      }
      if (!$("#div_home_phone").hasClass("hide")) {
        if(self.home_phone && self.home_phone != "___-___-____" && !self.home_phone.match(phoneRE)){
            self.home_phone_number_error_msg = "Home phone number must be in proper format";
            error = true;
        }
      }
      if (!$("#div_other_phone").hasClass("hide")) {
        if(self.other_phone && self.other_phone != "___-___-____"  && !self.other_phone.match(phoneRE)){
            self.other_phone_number_error_msg = "Other phone number must be in proper format";
            error = true;
        }
      }
    //   if (!$("#div_home_phone").hasClass("hide")) {
    //     if(self.home_phone && !self.home_phone.match(phoneRE)){
    //         self.home_phone_number_error_msg = "Home phone number must be in proper format";
    //         error = true;
    //     }
    //   }
    //   if (!$("#div_other_phone").hasClass("hide")) {
    //     if(self.other_phone && !self.other_phone.match(phoneRE)){
    //         self.other_phone_number_error_msg = "Other phone number must be in proper format";
    //         error = true;
    //     }
    //   }

      /* if(self.home_phone && String(self.home_phone).match(/^[0-9]*$/) && self.home_phone.length < 10){
        self.home_phone_number_error_msg = "Home Phone Must Be Of Minimum 10 Digits";
        error = true;
      }

      if(self.home_phone && String(self.home_phone).match(/^[0-9]*$/) && self.home_phone.length > 12){
        self.home_phone_number_error_msg = "Home Phone Must Be Of Maximum 12 Digits";
        error = true;
      }

      if(self.mobile_phone && !String(self.mobile_phone).match(/^[0-9]*$/)){
        self.mobile_phone_number_error_msg = "Mobile Phone Must Be Numeric";
        error = true;
      }

      if(self.mobile_phone && String(self.mobile_phone).match(/^[0-9]*$/) && self.mobile_phone.length < 10){
        self.mobile_phone_number_error_msg = "Mobile Phone Must Be Of Minimum 10 Digits";
        error = true;
      }

      if(self.mobile_phone && String(self.mobile_phone).match(/^[0-9]*$/) && self.mobile_phone.length > 12){
        self.mobile_phone_number_error_msg = "Mobile Phone Must Be Of Maximum 12 Digits";
        error = true;
      }

      if(self.other_phone && !String(self.other_phone).match(/^[0-9]*$/)){
        self.other_phone_number_error_msg = "Other Phone Must Be Numeric";
        error = true;
      }

      if(self.other_phone && String(self.other_phone).match(/^[0-9]*$/) && self.other_phone.length < 10){
        self.other_phone_number_error_msg = "Other Phone Must Be Of Minimum 10 Digits";
        error = true;
      }

      if(self.other_phone && String(self.other_phone).match(/^[0-9]*$/) && self.other_phone.length > 12){
        self.other_phone_number_error_msg = "Other Phone Must Be Of Maximum 12 Digits";
        error = true;
      } */

      /*if (!self.fax_no || self.fax_no == null || self.nfax_noame == "") {
        self.faxerrors = "Fax No is Required.";
        error = true;
      }*/
      // as fax no is optional so compared with default mask value and check phone number RE
      if(self.fax_no && self.fax_no != "___-___-____" && !self.fax_no.match(phoneRE)){
        self.faxerrors = "Fax No must be in proper format";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateCustomerContactBtn").val("Updating ...");
                $("#CreateCustomerContactBtn").prop("disabled", true);
                $("#cancelCustomerContactBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCustomerContactBtn").val("Saving ...");
                    $("#CreateCustomerContactBtn").prop("disabled", true);
                    $("#createAndContinueCustomerContactBtn").prop("disabled", true);
                    $("#cancelCustomerContactBtn").prop("disabled",true);

                }else{

                    $("#CreateCustomerContactBtn").val("Saving ...");
                    $("#CreateCustomerContactBtn").prop("disabled", true);
                    $("#createAndContinueCustomerContactBtn").prop("disabled", true);
                    $("#cancelCustomerContactBtn").prop("disabled",true);
                }

            }

            /*var notificationArr = [];

            if (self.invoices == true) {
                var invoices_checkbox_value = $("#invoices").value = self.invoices_value;
                notificationArr.push(invoices_checkbox_value);
            }

            if (self.cpi_rate_increase_mail == true) {
                var cpi_rate_mail_checkbox_value = $("#cpi_rate_increase_mail").value = self.cpi_rate_increase_mail_value;
                notificationArr.push(cpi_rate_mail_checkbox_value);
            }

            if (self.maintenance_mail == true) {
                var maintenance_mail_checkbox_value = $("#maintenance_mail").value = self.maintenance_mail_value;
                notificationArr.push(maintenance_mail_checkbox_value);
            }*/

            var fields = $("#CustomerContactForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({ name: "customer_id", value: self.customer_id.value });
            fields.push({ name: "is_default", value: self.is_default });
            fields.push({name: "state_id", value: self.state.value});
            fields.push({name: "city_id", value: self.city_id.value});
            fields.push({name: "designation", value: self.designation.value});
            // fields.push({name: "send_notification_types", value: notificationArr});
            if ( self.sendNotificationTypes.length > 0 ) {
                fields.push({name: "send_notification_types", value: self.sendNotificationTypes});
            }else{
                fields.push({name: "send_notification_types", value: "" });
            }

            if (!$("#div_mobile_phone").hasClass("hide")) {
                fields.push({name: "mobile_phone", value: self.mobile_phone});
            }else{
                fields.push({name: "mobile_phone", value: ""});
            }

            if (!$("#div_home_phone").hasClass("hide")) {
                fields.push({name: "home_phone", value: self.home_phone});
            }else{
                fields.push({name: "home_phone", value: ""});
            }

            if (!$("#div_other_phone").hasClass("hide")) {
                fields.push({name: "other_phone", value: self.other_phone});
            }else{
                fields.push({name: "other_phone", value: ""});
            }

            if (self.fax_no != "___-___-____") {
                fields.push({name: "fax_no", value: self.fax_no});
            }else{
                fields.push({name: "fax_no", value: ""});
            }

            $.ajax({
                url: process.env.ROOT_API + "/customercontact/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCustomerContactBtn").val("Update");
                        $("#CreateCustomerContactBtn").prop("disabled", false);
                        $("#cancelCustomerContactBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCustomerContactBtn").val("Save and Continue");
                            $("#CreateCustomerContactBtn").prop("disabled", false);
                            $("#createAndContinueCustomerContactBtn").prop("disabled", false);
                            $("#cancelCustomerContactBtn").prop("disabled",false);

                        }else{

                            $("#CreateCustomerContactBtn").val("Save");
                            $("#CreateCustomerContactBtn").prop("disabled", false);
                            $("#createAndContinueCustomerContactBtn").prop("disabled", false);
                            $("#cancelCustomerContactBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#CustomerContactForm").trigger("reset");
                            self.customer_id = null;
                            self.name = "";
                            self.email = "";
                            self.is_default = 0;
                            self.work_phone = "";
                            self.home_phone = "";
                            self.mobile_phone = "";
                            self.other_phone = "";
                            self.address_1 = "";
                            self.address_2 = "";
                            self.state = null;
                            self.city_id = null;
                            self.zip = "";
                            self.fax_no = "";
                            self.invoices = 0;
                            self.designation = "";
                            self.cpi_rate_increase_mail = 0;
                            self.maintenance_mail = 0;
                            self.sendNotificationTypes = [];

                        }else{
                            self.$router.push("/customercontact/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateCustomerContactBtn").val("Update");
                        $("#CreateCustomerContactBtn").prop("disabled", false);
                        $("#cancelCustomerContactBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#CustomerContactForm").trigger("reset");


                            $("#createAndContinueCustomerContactBtn").val("Save and Continue");
                            $("#CreateCustomerContactBtn").prop("disabled", false);
                            $("#createAndContinueCustomerContactBtn").prop("disabled", false);
                            $("#cancelCustomerContactBtn").prop("disabled",false);

                        }else{

                            $("#CreateCustomerContactBtn").val("Save");
                            $("#CreateCustomerContactBtn").prop("disabled", false);
                            $("#createAndContinueCustomerContactBtn").prop("disabled", false);
                            $("#cancelCustomerContactBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'create-contact')

                }
            });
      }else{
            self.errorValidationFocus();
      }

    },

    loadCustomerContact() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/customercontact/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.custName)};
                    self.name = data.content.name;
                    self.email = data.content.email;
                    self.is_default = data.content.is_default;

                    self.work_phone = data.content.work_phone;

                    setTimeout(function(){
                        self.mobile_phone = data.content.mobile_phone;
                        if ( data.content.mobile_phone != "" && data.content.other_phone != null) {
                            $("#div_mobile_phone").removeClass("hide");
                        } else{
                            self.mobile_phone = "";
                            $("#div_mobile_phone").addClass("hide");
                        }

                        self.home_phone = data.content.home_phone;
                        if ( data.content.home_phone != ""  && data.content.other_phone != null) {
                            $("#div_home_phone").removeClass("hide");
                        } else{
                            self.home_phone = "";
                            $("#div_home_phone").addClass("hide");
                        }

                        self.other_phone = data.content.other_phone;
                        if ( data.content.other_phone != "" && data.content.other_phone != null) {
                            $("#div_other_phone").removeClass("hide");
                        } else{
                            self.other_phone = "";
                            $("#div_other_phone").addClass("hide");
                        }

                        self.checkallPhoneInput();

                    },500)

                    if (data.content.zip == 0) {
                        self.zip = "";
                    } else {
                        self.zip = data.content.zip;
                    }

                    self.address_1 = data.content.address_1;
                    self.address_2 = data.content.address_2;
                    // self.designation = data.content.designation;
                    self.designation = {value: data.content.designation, text: data.content.designation};
                    if ( data.content.state_id != "" && data.content.state_id != null ) {
                        self.state = {value: data.content.state_id, text: data.content.stName};
                    } else {
                        self.state = null;
                    }
                    if ( data.content.city_id != "" && data.content.city_id != null ) {
                        self.city_id = {value: data.content.city_id, text: data.content.caName};
                    } else {
                        self.city_id = null;
                    }

                    self.fax_no = data.content.fax_no;

                    self.sendNotificationTypes = [];

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'load-contact')
            }
        });
    },

    validEmail: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    emailNotificationType(id,name,event) {
        var self = this;
        if (event.target.checked) {
            if (jQuery.inArray(id,self.sendNotificationTypes) == -1) {
                self.sendNotificationTypes.push(id);
            }
        }else{
            var index = self.sendNotificationTypes.indexOf(id);
            if (index !== -1) {
                self.sendNotificationTypes.splice(index, 1);
            }
        }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/CustomerContactCreate.vue